import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './card.module.scss';
import { Loader } from '@huggg/react-components';
import HugggImage from 'components/Huggg/HugggImage';
import CardContent from './CardContent';
import CardFooter from './CardFooter';

const CardReveal = ({
  huggg,
  brandAssets,
  redeemedSegmentImage,
  brandName,
  voucherAmount,
  formattedVoucherExpiry,
  processedVoucherLabel,
  isWaitingForFulfil,
  onClaimCard,
  isLoading,
  isBlueHuggg,
  voucherError,
  isTilloVoucher,
  hugggBrandName,
  ctaTitle,
  showSuccessTick,
  successMessage,
  confirmClaim
}) => {
  if (isLoading) {
    return <Loader className={styles.loader} />;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <HugggImage
        huggg={huggg}
        imageOverride={brandAssets.logoUrl || redeemedSegmentImage}
        className={classnames(styles.logoImage)}
      />

      <hr className={classnames(styles.divider)} />

      <CardContent
        isBlueHuggg={isBlueHuggg}
        brandAssets={brandAssets}
        brandName={brandName}
        voucherAmount={voucherAmount}
        formattedVoucherExpiry={formattedVoucherExpiry}
        processedVoucherLabel={processedVoucherLabel}
        isWaitingForFulfil={isWaitingForFulfil}
        onClaimCard={onClaimCard}
        voucherError={voucherError}
        isTilloVoucher={isTilloVoucher}
        hugggBrandName={hugggBrandName}
        ctaTitle={ctaTitle}
        confirmClaim={confirmClaim}
        showSuccessTick={showSuccessTick}
        successMessage={successMessage}
      />

      <CardFooter huggg={huggg} />
    </div>
  );
};

CardReveal.propTypes = {
  huggg: PropTypes.object.isRequired,
  brandAssets: PropTypes.object.isRequired,
  redeemedSegmentImage: PropTypes.string,
  brandName: PropTypes.string,
  voucherAmount: PropTypes.string,
  formattedVoucherExpiry: PropTypes.string,
  processedVoucherLabel: PropTypes.string,
  isWaitingForFulfil: PropTypes.bool.isRequired,
  onClaimCard: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  voucherError: PropTypes.object,
  isTilloVoucher: PropTypes.bool,
  hugggBrandName: PropTypes.string,
  ctaTitle: PropTypes.string,
  showSuccessTick: PropTypes.bool,
  successMessage: PropTypes.string,
  confirmClaim: PropTypes.shape({
    title: PropTypes.string,
    confirmButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string
  })
};

export default CardReveal;
